import { TEntityResponse, TMeUserResBody } from '@poseidon-city/api-sdk';
import { useQuery } from '@tanstack/react-query';

import { useApiSDK } from '../../contexts/apiSdkContext';

type TUserGet = {
  isError: boolean;
  isLoading: boolean;
  data: TEntityResponse<'user', TMeUserResBody> | undefined | null;
};

function useGetUser(isLogged: boolean): TUserGet {
  const sdk = useApiSDK();

  const { isError, isLoading, data } = useQuery({
    queryKey: ['user-me', isLogged],
    queryFn: async () => {
      if (!isLogged) {
        return null;
      }

      return sdk.users.me();
    },
    staleTime: 0,
    cacheTime: 0,
  });

  return { isError, isLoading, data };
}

export { useGetUser };
